import { Partner } from '@app/shared/_models/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { DatePipe } from '@angular/common';
import { ValuesService } from '@app/common/values/values.service';
import * as constants from "@app/shared/constants";
import { Subject, BehaviorSubject, Observable, pipe, Subscription,combineLatest, map } from 'rxjs';
import { AsyncPipe, JsonPipe } from '@angular/common';






@Component({
    selector: 'app-card-livraison',
    imports: [MatCardModule, NgClass, AsyncPipe, JsonPipe],
    templateUrl: './card-livraison.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './card-livraison.component.scss'
})
export class CardLivraisonComponent implements OnInit {
  @Input() order!: any ;

  deliveryOpAndSlot$!: Observable<any>; 
    constructor(private valuesService: ValuesService ) { }
  

    ngOnInit(): void {
      console.log('this.order',this.order);
      this.deliveryOpAndSlot$ = combineLatest({op:this.valuesService.getValues$(constants.C_VALUES_DELIVERY_OPERATOR), slot:this.valuesService.getValues$(constants.C_VALUES_DELIVERY_SLOT) })
        .pipe(  map((opAndSlots)=>(  this.getOpAndSlot(opAndSlots, this.order.lnk_delivery)  ) ) )
      // this.deliveryOpAndSlot$ = combineLatest ([ this.formGroup.valueChanges ,this.valuesService.getValues$(constants.C_VALUES_DELIVERY_MODE), this.valuesService.getValues$(constants.C_VALUES_DELIVERY_SLOT), this.valuesService.getValues$(constants.C_VALUES_DELIVERY_OPERATOR), ]  )

    }


    // Les adresses du client sont ses lignes de rôle -5 dans lnk_partner_partners (c_partner_partner).
    deliveryCity(order: any): string {
      const adresses = Partner.addresses(order?.lnk_customer);
      return adresses.length ? (this.findElementById(adresses as any, order?.addr_deliv)?.city ?? '') : '';
    }

    findElementById(arrayElmts : [any] , id : number) : any {
      // console.log('id',id);
      // console.log('arrayElmts.find( (elt) =>( elt.id === id) )',arrayElmts.find( (elt) =>( elt.id === id) ));
      return arrayElmts.find( (elt) =>( elt.id === id) );

    }

    getOpAndSlot(opAndSlots : any , lnkDelivery: any ) : string {
      if (!lnkDelivery || !lnkDelivery.mode || lnkDelivery.mode === 3) return 'Livraison dès que possible'
      let retour =''
      if(lnkDelivery.askop) {
        retour =  opAndSlots.op.find((op :any) => op.id == lnkDelivery.askop).name + ' ' ; 
      }
      retour += opAndSlots.slot.find((slot :any) => slot.id == lnkDelivery.askslot).name
      return retour;
      return lnkDelivery.mode;
      return 'Avant 15h'
    }

       getDeliverySlot(lnkDelivery: any): string {
            let retour ='';
            
            if(lnkDelivery.mode?.value === 4 && lnkDelivery.askslot >0 ){
                retour ='';
                // retour += new DatePipe(navigator.language || 'fr-FR').transform(formControl_lnkDelivery?.get('askdatdel')?.value,'dd/MM') +' '
                
                if (+lnkDelivery.askslot <3 && +lnkDelivery.askslotoperator <4) {   // morning or afternoon case
                    if(+lnkDelivery.askslotoperator.value >0){ // debut milieu fin case
                         switch (+lnkDelivery.askslotoperator ) {
                            case 1 : retour +='début ' ; break;
                            case 2 : retour +='milieu '; break;
                            case 3 : retour +='fin '; break;
                        }
                    }
                    switch (+lnkDelivery.askslot ) {
                        case 1 : retour +='Matinée' ; break;
                        case 2 : retour +='Après Midi'; break;
                    } 
                    return retour;
        
                } else  if (+lnkDelivery.askslot >2  &&  +lnkDelivery.askslotoperator >3  ){  // slot is an hour we need operator
                     
                        switch (+lnkDelivery.askslotoperator ) {
                            case 4 : retour +='Avant  ' ; break;
                            case 5 : retour +='Après '; break;
                            case 6 : retour +='Heure précise '; break;
                        }
                    
                    // retour += this.slots.find(slot => slot.id ===formControl_lnkDelivery?.get('askslot')?.value ).name 
                    retour +=lnkDelivery.askslot. toString()  // todo use the slot 
                    return retour;
                } 
            } 
            return 'Avant 15h'
            return 'dès que possible'
            }


}
